// src/config.js
export const items = [
    {
        "name": "驯龙口哨",
        "identifier": "dragon_taming_whistle",
        "description": "能够控制龙的行为,包括跟随、坐下、召唤.可以装于副手."
    },
    {
        "name": "鳗鱼",
        "identifier": "eel",
        "description": "玩家手持鳗鱼会让龙远离鳗鱼,但是玩家若是用鳗鱼攻击龙,还是会受到攻击"
    },
    {
        "name": "隐匿烟幕",
        "identifier": "hidden_smoke_screen",
        "description": "在战斗或探险中提供即时的遮蔽，帮助玩家或队伍暂时隐形或逃脱敌人视线."
    },
    {
        "name": "纯净灵药",
        "identifier": "pure_elixir",
        "description": "这瓶灵药拥有驱散所有负面状态的力量，并赋予饮用者强大的正面效果，是探险者不可或缺的宝物."
    },
    {
        "name": "沉眠之雾",
        "identifier": "sleeping_mist",
        "description": "在脚下释放出一片梦幻般的区域，让所有进入其中的生物沉入深深的梦境，忘却战斗."
    },
    {
        "name": "腐蚀之雨药剂",
        "identifier": "corrosive_rain_potion",
        "description": "这瓶药剂一旦破碎，便会释放出腐蚀性极强的液体，能够溶解岩石、木材和金属，对其中的生物造成极大的伤害.几秒后，腐蚀区域将化为熊熊烈火，燃尽一切."
    },
    {
        "name": "毒雾宝珠",
        "identifier": "poison_mist_orb",
        "description": "当这颗宝珠破碎时，它会释放出致命的毒雾，覆盖一定区域，对其中的生物造成持续伤害.若在雷电之地释放，毒雾会与雷电交织，引发壮观的火焰爆炸."
    },
    {
        "name": "雷霆之珠",
        "identifier": "thunder_pearl",
        "description": "投掷而出，碰撞之处即成为雷电的领域，对进入者释放无情的电击.与毒雾相遇，便激发出火焰的怒吼，燃烧一切."
    },
    {
        "name": "狂风之心",
        "identifier": "heart_of_the_storm",
        "description": "召唤强风以推开敌人或清除路径上的障碍物."
    },
    {
        "name": "隐匿斗篷",
        "identifier": "cloak_of_invisibility",
        "description": "在玩家不主动攻击时赋予玩家隐形能力.可以装于副手."
    },
    {
        "name": "光之晶体",
        "identifier": "crystal_of_light",
        "description": "作为强大的光源,带在身上可作为移动光源.可以装于副手."
    },
    {
        "name": "复活药水",
        "identifier": "resurrection_potion",
        "description": "用世间神圣的物质造就的药水,能够复活逝去的灵魂."
    },
    {
        "name": "忘却药水",
        "identifier": "wash_some_medicine",
        "description": "能够让生物忘却一切,重新开始."
    },
    {
        "name": "生成红女王祭坛",
        "identifier": "red_death_summon_place_item",
        "description": "隐含着及其强大的力量,能够生成召唤恐怖生物的祭坛!"
    }
];